import { apiGet } from '../_common';

export default {
  getItemById(id) {
    return apiGet(`/magenta/billing/item/${id}`)
      .then(result => result.response);
  },
};
